import { Loader } from "@components/atoms";
import React from "react";
import * as S from "./styles";
export var UpdateCheckout = function UpdateCheckout() {
  return React.createElement(S.Loader, null, React.createElement(Loader, null));
};
export default UpdateCheckout;